export const hy = {
  title: 'Տրոպիկական ծառի ծածկոց',
  subtitle: '2020, 10 m/0.5 ha, tropical, WRI',
  download_data: 'https://data.globalforestwatch.org/datasets/tropical-tree-cover/explore',
  learn_more: '',
  content: [
    {
      label: 'Գործառույթ',
      value:
        'Ցուցադրում է տասը մետր սանդղակով ծառերի ծավալն ու ծառերի ծածկը կես հեկտարի սանդղակով, որպեսզի կարողանա ճշգրիտ վերահսկել ծառերը քաղաքային տարածքներում, գյուղատնտեսական հողերում եւ բաց կանաչապատ եւ չոր անտառային էկոհամակարգերում',
    },
    {
      label: 'Բանաձեւ',
      value: '10 x 10 մետր, կես հա',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: '4,3 մլրդ հա տրոպիկական (-23.44-ից 23.44 լայնություն)',
    },
    {
      label: 'Աղբյուր',
      value: 'World Resources Institute',
    },
    {
      label: 'Հաճախականություն',
      value: '2017թ.-ից սկսած տարեկան փոփոխությունների հայտնաբերման քարտեզները պլանավորվում են 2024թ. թողարկման համար:',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: '2020',
    },
    {
      label: 'Զգուշացումներ',
      value:
        'Այս dataset-ը օգտագործում է ծառի այլ սահմանում եւ ծառի ծածկույթի այլ սահմանում, քան Hansen et al. (2013)։ Այս dataset-ը սահմանում է ծառը ըստ բարձրության եւ պսակի տրամագծի: 5 մետրից բարձր վուդի բուսածածկույթը՝ անկախ պսակի տրամագիծից, կամ 3-ից 5 մ նվազագույն պսակի տրամագիծ ունեցող 5 մ-ը համարվում է ծառ: Այս սահմանումը տարբերվում է Hansen et al. (2013) -ից, որը սահմանում է ծառը որպես ցանկացած բուսականություն առնվազն 5 մետր բարձրությամբ: Արեւադարձային ծառի ծածկոց dataset-ը չի տրոհում պլանտացիաների ծառերը ոչ պլանտացիաների ծառերից:\n\n0,5 հա-ից փոքր ձեւերի համար ստացված վերլուծությունները կամ վիճակագրությունը կարող է ճշգրիտ չլինել:',
    },
    {
      label: 'Լիցենզիա',
      value: 'CC 4.0',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'Արեւադարձային ծառը ծածկում է տվյալների քարտեզը, որը կազմում է տասը մետր սանդղակով ծառը, իսկ ծառերի ծածկը՝ կես հեկտարի մասշտաբով, որպեսզի հնարավոր դարձվի ճշգրիտ վերահսկել ծառերը քաղաքային տարածքներում, գյուղատնտեսական հողերում եւ բաց կանեփի եւ չոր անտառային էկոհամակարգերի մեջ։ Տվյալները տարածվում են համաշխարհային արեւադարձային գոտիների ավելի քան 4,3 միլիարդ հեկտարի վրա:\n\nՏվյալները ստացվում են բազմաժամանակյա կոնվոլյուցիոն նյարդային ցանցի մոդելներից, որոնք կիրառվում են Sentinel օպտիկական եւ ռադարային պատկերների վրա։ 10 մետրանոց տվյալների բազան երկնիշ ծառի ծավալային շերտ է, որը նման է ցամաքային ծածկույթի քարտեզին, իսկ ծառի ծածկման տվյալները ներկայացնում են կես հա մասշտաբով կոտորակային ծածկույթ: Մեթոդաբանության եւ վերլուծությունների մասին ավելի մանրամասն կարող եք գտնել GitHub էջում:',
  },
  citation: {
    label: 'Մեջբերում',
    value:
      'Use the following credit when this data is displayed: Source: 14/02/2025, accessed through Global Forest Watch on 14/02/2025\n\nUse the following credit when this data is cited: Brandt,\nBrandt, J., Ertel, J., Spore, J., & Stolle, F. (2023). WALL-to-wall\nmapping of tree extent in the tropics with sentinel-1 and sentinel-2. Remote Sensing of Environment, 292, 113574. https://doi.org/10.1016/j.rse.2023.11357',
  },
};
